import { CaretLeft } from 'phosphor-react'

import { colors, sizes } from '@motrix/tokens'

import { PhosphorIconProps } from './interfaces'

export const ArrowLeft = ({
  color = colors.neutral09,
  size = '4',
  weight = 'regular',
}: PhosphorIconProps) => {
  return <CaretLeft size={sizes[size]} weight={weight} color={color} />
}
